<template>  
    <div :style="shu.yangshi" class="zidingyi_Dingdan box_show">
		<div class="zidingyi_Dingdan_top">
			<span class="zidingyi_Dingdan_top_wenzi ziti12px">我的订单</span>
			<div class="zidingyi_Dingdan_top_wenzi2 ziti12px">全部订单 <span>></span></div>
		</div>
		<div class="zidingyi_Dingdanlei">
			<div  v-for="l in dindan" class="zidingyi_Dingdan_box">
			<img :src="l.icon" alt="" class="zidingyi_Dingdan_img">
			<div class="zidingyi_Dingdan_zhuantai ziti12px">{{l.name}}</div>
			<span class="zidingyi_Dingdan_dindanshu">{{l.dindanshu}}</span>
			</div>
		</div>
	</div> 	
</template>

<script>
export default {
  name: 'anniu',
  data(){
	  return{
		  dindan:[
			  {name:'全部订单',icon:'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/omp3FPw6WTm6qg5izqyqgGWqTrjWqK.png',dindanshu:"2"},
			  {name:'待付款',icon:'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/q6vv3RTtxIk3vvrRh6Vu0LVrZ9UfUV.png',dindanshu:"3"},
			  {name:'待提货',icon:'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/LJNSUstCJssAS96ur7J9U1s44yfsY2.png',dindanshu:"4"},
			  {name:'已提货',icon:'http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_11/fCULUUlo9unJcNlC5KB555c050gw0c.png',dindanshu:"5"}]
	  }
  },
  props: {
       shu: {
		   type:Object,
		   default(){
			   return {wenzi:'输入文字',yangshi:{}}
		   }
		}
  },
  
}
</script>



